module.exports = __webpack_public_path__ + "static/media/SVGattendence.bbcb8cbb.svg";